import { render, staticRenderFns } from "./HistoriqueDocument.vue?vue&type=template&id=5e8903cb"
import script from "./HistoriqueDocument.vue?vue&type=script&lang=js"
export * from "./HistoriqueDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports